<template>
	<div class="progress">
		<div class="bar" :style="{width: percent + '%'}"></div>
		<div class="users">{{ value }} / {{ max }}</div>
	</div>
</template>

<script>
export default {
	name: "Progress",
	props: ["value", "max"],

	computed: {
		percent() {
			return parseInt((this.value / this.max) * 100);
		},
	},
};
</script>


<style lang="scss">
.progress {
	border-radius: 20px;
	overflow: hidden;
	width: 100%;
	height: 32px;
	position: relative;
	// border: 1px solid rgba(0, 0, 0, 0.1);

	// background: linear-gradient(
	// 	135deg,
	// 	rgba(0, 0, 0, 0.1) 0%,
	// 	rgba(0, 0, 0, 0.4) 100%
	// );

	background: linear-gradient(
		90deg,
		rgba(0, 0, 0, 0.1) 0%,
		rgba(0, 0, 0, 0.7) 100%
	);

	.bar {
		background-color: white;
		position: absolute;
		left: 0px;
		top: 0px;
		bottom: 0px;
		transition: 0.5s;
		// border-radius: 20px;
	}

	.users {
		position: absolute;
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 500;
		font-size: 15px;
		// color: black;
		color: white;
		mix-blend-mode: difference;
	}
}
</style>